import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getCompany } from './company.selectors';

export const getPropertyDefinitions = createSelector(
  getCompany,
  ({ propertyDefinitions }) => propertyDefinitions,
);

const getCompanyPropertyKeys = createSelector(getPropertyDefinitions, definitions =>
  (definitions || []).map(({ propertyKey }) => propertyKey),
);

export const getFilteredCompanyProperties = createSelector(
  getDebouncedSearchValue,
  getCompanyPropertyKeys,
  searchItems(propertyKey => [propertyKey]),
);
